import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/pricing/teams")({
  beforeLoad: () => {
    throw redirect({ to: "/implementation", replace: true });
  },
});
